<style scoped lang="css"></style>

<template>
  <div class="main-wrapper">
    <section class="section main-section bg-gradient-default min-vh-100 pt-3">
      <main class="container card shadow shadow-lg--hover mb-3" id="main">
        <Header title="Hojas de servicio" />
        <div class="text-center" :class="loading ? 'mb-3' : ''">
          <b-spinner variant="light" type="grow" v-show="loading"></b-spinner>
        </div>
        <div v-show="!loading">
          <b-row class="mb-3">
            <b-col cols="6">
              <b-button-toolbar>
                <b-button variant="default" size="sm" @click="goBack">
                  <b-icon-chevron-left scale="1.3" />
                </b-button>
                <b-button
                  variant="success"
                  size="sm"
                  @click="goToTemplateForm"
                  v-if="isAdmin"
                >
                  <b-icon-plus scale="1.7" />
                </b-button>
              </b-button-toolbar>
            </b-col>
            <b-col cols="6">
              <b-button-toolbar class="float-right">
                <b-button-group>
                  <b-button variant="primary" size="sm" @click="refresh">
                    <b-icon-arrow-clockwise scale="1.3" />
                  </b-button>
                </b-button-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <b-list-group class="mb-3" v-show="!loading">
            <b-list-group-item
              v-for="template in templates"
              :key="template.id"
              class="flex-column align-items-start"
            >
              <div class="d-flex justify-content-between">
                <h5 class="mb-1">{{ template.name }}</h5>
                <small>Revision: #{{ template.revision }}</small>
              </div>

              <div>
                <p>
                  Checklist contiene
                  {{ template.questions.length }} preguntas.
                </p>
                <small class="text-muted">
                  Creado hace {{ template.createdOn | timestamp }} y modificado
                  hace {{ template.lastUpdatedAt | timestamp }}
                </small>
              </div>
              <b-button-toolbar class="mt-1" justify>
                <b-button-group class="ml-1 mt-1">
                  <b-button
                    variant="default"
                    size="sm"
                    @click.stop="goToRevisions(template)"
                  >
                    Revisiones
                  </b-button>
                  <b-button
                    variant="warning"
                    @click="goToRevisionForm(template)"
                    size="sm"
                    v-if="isAdmin"
                  >
                    Nueva Revision
                  </b-button>
                </b-button-group>
              </b-button-toolbar>
            </b-list-group-item>
          </b-list-group>
        </div>
      </main>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";
import Header from "../Header";

moment.locale("es");

export default {
  name: "Templates",
  components: {
    Header,
  },
  data() {
    return {
      loading: true,
    };
  },
  created() {
    this.fetchTemplates().then(() => {
      this.loading = false;
    });
  },
  computed: {
    ...mapGetters("templates", {
      templates: "getTemplates",
    }),
    ...mapGetters("checklists", {
      getEntries: "getEntries",
    }),
    ...mapState("checklists", ["entries"]),
    ...mapGetters("auth", ["isAdmin"]),
  },
  methods: {
    ...mapActions("templates", ["fetchTemplates"]),
    ...mapActions("checklists", ["fetchCheckListEntriesFromTemplate"]),
    async refresh() {
      this.loading = true;
      try {
        await this.fetchTemplates();
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.push("/");
    },
    goToRevisions(template) {
      this.$router.push(`/templates/${template.id}`);
    },
    goToRevisionForm(template) {
      this.$router.push(`/templates/${template.id}/revision`);
    },
    goToTemplateForm() {
      this.$router.push(`/templates/revision`);
    },
  },
  filters: {
    timestamp(value) {
      return moment(value).fromNow();
    },
  },
};
</script>
